import { Outlet } from 'react-router-dom';
import AppLayout from '@/components/layout/AppLayout';
import SettingsSidebar from '@/components/settings/SettingsSidebar';
import { AcquirersProvider } from '@/contexts/AcquirersContext';

export default function ConfiguracionesLayout() {
  return (
    <AcquirersProvider>
      <AppLayout>
        <div className="flex flex-col md:flex-row gap-8 items-start">
          <SettingsSidebar />
          <div className="flex-grow w-full">
            <Outlet />
          </div>
        </div>
      </AppLayout>
    </AcquirersProvider>
  );
}
